@if (selectedZone) {
    <div class="center-xy" [style.overflow]="overflow ? 'auto' : 'hidden'">
        <div class="zone-control-wrapper bg-light" data-testid="valve-info">
            <div class="zone-control__top">
                <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                    <img [ngSrc]="iconSrc" width="45" height="45" alt=""/>
                </div>
                <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                    {{ zoneName }}
                </p>
            </div>
            <div class="zone-control__content">
                <div class="zone-control__buttons-top">
                    <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                         data-testid="back-button" (click)="goBack()">
                        <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                             width="40" height="40" alt=""/>
                    </div>
                </div>
                <simple-valve-parameters [tile]="selectedZone.tile"/>
            </div>
        </div>
    </div>
}
